import { DOCUMENT } from "@angular/common";
import { inject, Injectable } from "@angular/core";

/**
 * Provides access to browser document-related helpers used across the app.
 */
@Injectable({ providedIn: "root" })
export class DocumentHelpersService {
  /**
   * The Angular-injected browser document instance.
   */
  readonly document = inject(DOCUMENT);

  /**
   * Returns the current viewport width from the root document element.
   */
  get getDocumentWidth() {
    return this.document.documentElement.clientWidth;
  }

  /**
   * Indicates whether the current viewport width is within the mobile breakpoint.
   *
   * The breakpoint value is read from the `--breakpoints-sm` CSS variable
   * (fallback: `576px`).
   */
  get isMobile() {
    return parseFloat(getComputedStyle(this.document.documentElement).getPropertyValue("--breakpoints-sm") || "576px") >= this.getDocumentWidth;
  }
}
